import { ButtonProps } from '../../types';
import './Button.css';

function Button(props: ButtonProps) {
    return (
        <div id="button">
            <button 
                id={props.id} 
                type={props.type} 
                disabled={props?.loading}
                {...props.props}
            >
                {props.loading ? "Loading..." : props.name}
            </button>
        </div>
    );
}

export default Button;